import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private httpClient = inject(HttpClient);

  getConfigItem(path: string): Observable<any> {
    return this.httpClient.get<any>(path);
  }
}
